module.exports = __webpack_public_path__ + "img/ic_64_water.f1cf08af.svg";